import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import {
  isValid,
  REQUIRED,
  validate,
} from "../../utils/Validation";
import ImageUpload from "../../components/ImageUpload";
import { baseUrl } from "../../api/Client";
import { RiPencilFill } from "react-icons/ri";
import CheckBox from "../../components/CheckBox";


export default function EditDrink({ selected, onClose, onSave }) {
  const [drink, setDrink] = useState({
    nameBr: "",
    locked: false,
    icon: null,
    logo: null,
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setDrink(selected);
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
  }, [selected]);

  const clear = () => {
    setDrink({
      nameBr: "",
      locked: false,
      icon: null,
      logo: null,
    });
    setErrors({});
    setSubmitting(false);
  };

  const save = async () => {
    setSubmitting(true);
    const rules = {
      nameBr: REQUIRED,
    };
    const errors = await validate(rules, drink);
    if (isValid(errors)) {
      onSave(drink);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={drink?.id ? "Editar Bebida" : "Nova Bebida"}
      Action={
        <Button disabled={submitting} submitting={submitting} onClick={() => save()}>
          {!!drink?.id ? "Salvar" : "Cadastrar"}
        </Button>}
    >
      <TextField
        className="mb-5"
        Icon={RiPencilFill}
        placeholder="Insira um nome"
        value={drink}
        field="nameBr"
        update={setDrink}
        errors={errors}
      />

      <CheckBox
        label="Liberado?"
        value={!drink?.locked}
        update={(value) => setDrink(dt => ({ ...dt, ...{ locked: !value } }))}
        labelClassName="text-white"
        className="mb-4"
      />

      <h2 className="font-bold text-white text-lg">Ícone</h2>
      <ImageUpload
        value={
          drink?.icon
            ? drink?.icon
            : drink?.id
            ? `${baseUrl}/img/drinkIcon/${drink?.id}/200/200?count=${drink?.iconCount}`
            : null
        }
        onChange={(icon) =>
          setDrink((u) => {
            let drink = { ...u };
            drink.icon = icon;
            return drink;
          })
        }
      />

      <h2 className="font-bold text-white text-lg">Logo</h2>
      <ImageUpload
        contain
        value={
          drink?.logo
            ? drink?.logo
            : drink?.id
            ? `${baseUrl}/img/drinkLogo/${drink?.id}?count=${drink?.logoCount}`
            : null
        }
        onChange={(logo) =>
          setDrink((u) => {
            let drink = { ...u };
            drink.logo = logo;
            return drink;
          })
        }
        error={errors["logo"]}
      />
      <div className="h-20" />
    </Modal>
  );
}
